import { Box, Button, Grid, Typography } from '@mui/material';
import React from 'react';
import moment from 'moment';
import {
  BusinessCenterRounded,
  BusinessRounded,
  CallRounded,
  EmailRounded,
  HowToRegRounded,
  LinkRounded,
  LocationCityRounded,
  LocationOnRounded,
  MyLocationRounded,
  PersonRounded,
  PhoneIphoneRounded,
  PublicRounded,
  RecentActorsRounded,
  WatchLaterRounded,
} from '@mui/icons-material';
import parse from "html-react-parser";


import { useResponsiveStyles } from '../../../utils/responsiveStyles';
import palette from '../../../theme/palette';

const CompanyDetails = ({ customerDetailsData }) => {
  const styles = useResponsiveStyles();

  function daysRemaining(date) {
    const expiryDate = moment(date).startOf('day');
    const todaysDate = moment().startOf('day');
    return expiryDate.diff(todaysDate, 'days');
  }

  const boxListStyles = {
    display: 'flex',
    gap: '20px',
    p: '10px',
  };

  const text1Styles = {
    m: 0,
    fontSize: styles.fontSize12,
    fontWeight: 500,
    color: palette.grey[800],
  };

  const iconStyles = {
    fontSize: styles.icon20,
    color: palette.grey[500],
  };
  const listItemGridStyles = {
    borderBottom: `1px solid ${palette.grey[200]}`
  }
  const listItemGridContainerStyles = {
    alignItems:'center'
  }
  const box1Styles = {display:'flex', gap:'16px', p:'10px'}

  return (
    <Grid container spacing={0}>
      <Grid item xs={12}>
        <Box sx={{ p: '6px', height: 400, overflow:'scroll' }}>
          <Grid container spacing={0}>
            <Grid xs={12} sx={{p:'10px'}}>
                <Typography paragraph sx={{fontSize: styles.fontSize14}}>
                    {parse(customerDetailsData?.companyDetails?.description)}
                </Typography>
            </Grid>
            <Grid item xs={12} sx={listItemGridStyles}>
            <Box sx={box1Styles}>
            <BusinessRounded sx={iconStyles} />
              <Typography paragraph sx={{ ...text1Styles }}>
              {customerDetailsData?.companyDetails?.name}
              </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sx={listItemGridStyles}>
            <Box sx={box1Styles}>
            <LocationOnRounded sx={iconStyles} />
              <Typography paragraph sx={{ ...text1Styles }}>
              {`${customerDetailsData?.companyDetails?.address1}, ${customerDetailsData?.companyDetails?.cityname}, ${customerDetailsData?.companyDetails?.statename} ${customerDetailsData?.companyDetails?.zipcode}`}
              </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sx={listItemGridStyles}>
            <Box sx={box1Styles}>
            <PersonRounded sx={iconStyles} />
              <Typography paragraph sx={{ ...text1Styles }}>
              {customerDetailsData?.companyDetails?.contactname}
              </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sx={listItemGridStyles}>
            <Box sx={box1Styles}>
            <CallRounded sx={iconStyles} />
              <Typography paragraph sx={{ ...text1Styles }}>
              {customerDetailsData?.companyDetails?.contactphone}
              </Typography>
              </Box>
            </Grid>
            
            <Grid item xs={12} sx={listItemGridStyles}>
            <Box sx={box1Styles}>
            <EmailRounded sx={iconStyles} />
              <Typography paragraph sx={{ ...text1Styles }}>
              {customerDetailsData?.companyDetails?.contactemail}
              </Typography>
              </Box>
            </Grid>
            {/* <Grid item xs={12} sx={listItemGridStyles}>
            <Box sx={box1Styles}>
            <BusinessRounded sx={iconStyles} />
              <Typography paragraph sx={{ ...text1Styles }}>
              {customerDetailsData?.companyDetails?.companysize}
              </Typography>
              </Box>
            </Grid> */}
            <Grid item xs={12} sx={listItemGridStyles}>
            <Box sx={box1Styles}>
            <LinkRounded sx={iconStyles} />
              <Typography paragraph sx={{ ...text1Styles }}>
              {customerDetailsData?.companyDetails?.url}
              </Typography>
              </Box>
            </Grid>
          </Grid>
          {/* <Box>
            <Box sx={boxListStyles}>
              <LocationOnRounded sx={iconStyles} />
              <Typography paragraph sx={{ ...text1Styles }}>
                {`${customerDetailsData?.userDetails?.zipcode}, ${customerDetailsData?.userDetails?.cityname}, ${customerDetailsData?.userDetails?.statename}.`}
              </Typography>
            </Box>
            <Box sx={boxListStyles}>
              <CallRounded sx={iconStyles} />
              <Typography paragraph sx={{ ...text1Styles }}>
                {customerDetailsData?.userDetails?.phone_number}
              </Typography>
            </Box>
            <Box sx={boxListStyles}>
              <EmailRounded sx={iconStyles} />
              <Typography paragraph sx={{ ...text1Styles }}>
                {customerDetailsData?.userDetails?.username}
              </Typography>
            </Box>
            <Box sx={boxListStyles}>
              <BusinessCenterRounded sx={iconStyles} />
              <Typography paragraph sx={{ ...text1Styles }}>
                {customerDetailsData?.userDetails?.role}
              </Typography>
            </Box>
            <Box sx={boxListStyles}>
              <PublicRounded sx={iconStyles} />
              <Typography paragraph sx={{ ...text1Styles, textDecoration: 'underline' }}>
                {`${customerDetailsData?.companyDetails?.domain_name}`}
              </Typography>
            </Box>
          </Box> */}
        </Box>
      </Grid>
    </Grid>
  );
};

export default CompanyDetails;
